import {ReactComponent as AngleLeftSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/angle-left-8.svg"
import {ReactComponent as AngleRightSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/angle-right-9.svg"
import {ReactComponent as ArrowLeftSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/arrow-left-12.svg"
import {ReactComponent as ArrowRightSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/arrow-right-211.svg"
import {ReactComponent as SplitArrowSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/split-arrow-133.svg"
import {ReactComponent as NewCommentSvg } from "./orion_full_svg/orion_communication_svg/Communication_icons_line/new-comment-4750.svg"
import {ReactComponent as MedicalChartSvg } from "./orion_full_svg/orion_health-medical_svg/Health-Medical_icons_line/medical-chart-6333.svg"
import {ReactComponent as MenuSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/menu-229.svg"
import {ReactComponent as CloseSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/close-3.svg"
import {ReactComponent as CloseSquareSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/close-square-46.svg"
import {ReactComponent as WrenchSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/wrench-5965.svg"
import {ReactComponent as PencilSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/pencil-1466.svg"
import {ReactComponent as TimeKeepingSvg } from "./orion_full_svg/orion_miscellaneous_svg/Miscellaneous_icons_line/timekeeping-5886.svg"
import {ReactComponent as GridLayoutSvg } from './orion_full_svg/orion_interface_svg/Interface_icons_line/grid-layout-137.svg'
import {ReactComponent as SmileySvg } from './orion_full_svg/orion_social-people_svg/Social-People_icons_line/smiley-2787.svg'
import {ReactComponent as TractorSvg } from './orion_full_svg/orion_transportation_svg/Transportation_icons_line/tractor-3207.svg'
import {ReactComponent as AgendaSvg } from './orion_full_svg/orion_books-text_svg/Books-Text_icons_line/agenda-3527.svg'
import {ReactComponent as ContentPostSvg } from './orion_full_svg/orion_books-text_svg/Books-Text_icons_line/content-post-3595.svg'
import {ReactComponent as MenuFullSvg } from './orion_full_svg/orion_interface_svg/Interface_icons_solid/menu-5672.svg'
import {ReactComponent as LogoutSvg } from './orion_full_svg/orion_interface_svg/Interface_icons_line/logout-123.svg'
import {ReactComponent as LockSvg } from './orion_full_svg/orion_edition_svg/Edition_icons_line/lock-1443.svg'
import {ReactComponent as ChatAppSvg } from './orion_full_svg/orion_communication_svg/Communication_icons_line/chat-app-4766.svg'
import {ReactComponent as SunAndMoonSvg } from './orion_full_svg/orion_weather_svg/Weather_icons_line/sun-and-moon-4308.svg'
import {ReactComponent as FilterDataSvg } from "./orion_full_svg/orion_hardware-software_svg/Hardware - Software_icons_line/filter-data-1839.svg"
import {ReactComponent as EditTextSvg } from "./orion_full_svg/orion_archives_svg/Archives_icons_line/edit-text-3925.svg"
import {ReactComponent as UserAddressSvg } from "./orion_full_svg/orion_social-people_svg/Social-People_icons_line/user-address-2736.svg"
import {ReactComponent as WebcamSvg } from "./orion_full_svg/orion_media_svg/Media_icons_line/webcam-5008.svg"
import {ReactComponent as MessagingAppSvg } from "./orion_full_svg/orion_communication_svg/Communication_icons_line/messaging-app-4767.svg"
import {ReactComponent as EditSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/edit-1467.svg"
import {ReactComponent as DeleteSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/delete-1476.svg"
import {ReactComponent as ViewSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/view-1460.svg"
import {ReactComponent as HiddenSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/hidden-1461.svg"
import {ReactComponent as BusinessReportSvg } from "./orion_full_svg/orion_e-commerce_svg/E-Commerce_icons_line/business-report-2326.svg"
import {ReactComponent as TrashSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/trash-1479.svg"
import {ReactComponent as SearchSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/search-23.svg"
import {ReactComponent as SearchFindSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/search-find-225.svg"
import {ReactComponent as MoreSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_solid/more.svg"
import {ReactComponent as EditUserSvg } from "./orion_full_svg/orion_social-people_svg/Social-People_icons_line/edit-user-2727.svg"
import {ReactComponent as Edit2Svg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/edit-1469.svg"
import {ReactComponent as DeleteCircleSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/delete-circle-32.svg"
import {ReactComponent as CheckedCircleSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/checked-circle-33.svg"
import { ReactComponent as PriorityWarningSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/priority-warning-163.svg"
import { ReactComponent as HexagonalWarningSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/warning-166.svg"
import {ReactComponent as PlusSvg} from "./orion_full_svg/orion_interface_svg/Interface_icons_line/plus-187.svg"
import {ReactComponent as MinusSvg} from "./orion_full_svg/orion_interface_svg/Interface_icons_line/minus-191.svg"
import {ReactComponent as GpsMapSvg} from "./orion_full_svg/orion_location_svg/Location_icons_line/gps-map-703.svg"
import { ReactComponent as SquareBulletedListSvg } from "./orion_full_svg/orion_books-text_svg/Books-Text_icons_line/square-bulleted-list-3591.svg"
import { ReactComponent as AimSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/aim-1523.svg"
import { ReactComponent as SquareSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/vector-1546.svg"
import { ReactComponent as QrCodeSvg } from "./orion_full_svg/orion_e-commerce_svg/E-Commerce_icons_line/qr-code-2337.svg"
import { ReactComponent as PaperStackSvg } from "./orion_full_svg/orion_books-text_svg/Books-Text_icons_line/paper-stack-3498.svg"
import { ReactComponent as AngleDownSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/angle-down-6.svg"
import { ReactComponent as AngleUpSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/angle-up-7.svg"
import { ReactComponent as AddCircleSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/add-circle-30.svg"
import { ReactComponent as BinSvg } from "./orion_full_svg/orion_edition_svg/Edition_icons_line/bin-1477.svg"
import { ReactComponent as SynchronizeSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/synchronize-73.svg"
import { ReactComponent as DownloadSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/download-93.svg"
import { ReactComponent as FilesSvg } from "./orion_full_svg/orion_archives_svg/Archives_icons_line/files-3868.svg"
import { ReactComponent as UploadSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/upload-94.svg"
import { ReactComponent as DocumentSvg } from "./orion_full_svg/orion_archives_svg/Archives_icons_line/document-3867.svg"
import { ReactComponent as EraserSvg } from "./orion_full_svg/orion_books-text_svg/Books-Text_icons_line/eraser-3602.svg"
import { ReactComponent as ReloadSvg } from "./orion_full_svg/orion_interface_svg/Interface_icons_line/reload-72.svg"
import { ReactComponent as AddPinSvg } from "./orion_full_svg/orion_location_svg/Location_icons_line/add-location-634.svg"


interface IconLibI {
    angleLeftSvg: any;
    angleRightSvg: any;
    arrowLeftSvg: any;
    arrowRightSvg: any;
    newCommentSvg: any;
    medicalChartSvg: any;
    menuSvg: any;
    closeSquareSvg: any;
    wrenchSvg: any;
    pencilSvg: any;
    timeKeepingSvg: any;
    gridLayoutSvg: any;
    smileySvg: any;
    tractorSvg: any;
    agendaSvg: any;
    contentPostSvg: any;
    menuFullSvg: any;
    logoutSvg: any;
    lockSvg: any;
    chatAppSvg: any;
    sunAndMoonSvg: any;
    filterDataSvg: any;
    editTextSvg: any;
    userAddressSvg: any;
    webcamSvg: any;
    messagingAppSvg: any;
    editSvg: any;
    edit2Svg: any;
    deleteSvg: any;
    deleteCircleSvg: any;
    viewSvg: any;
    hiddenSvg: any;
    businessReportSvg: any;
    trashSvg: any;
    closeSvg: any;
    searchSvg: any;
    searchFindSvg: any;
    moreSvg: any;
    editUserSvg: any;
    splitArrowSvg: any;
    priorityWarningSvg: any;
    plusSvg: any;
    minusSvg: any;
    gpsMapSvg: any;
    squareBulletedListSvg: any;
    aimSvg: any;
    squareSvg: any;
    qrCodeSvg: any;
    paperStackSvg: any;
    angleDownSvg: any;
    angleUpSvg: any;
    addCircleSvg: any;
    binSvg: any;
    synchronizeSvg: any;
    downloadSvg:any;
    filessvg:any;
    uploadSvg:any;
    documentSvg:any;
    hexagonalWarningSvg:any;
    eraserSvg:any;
    reloadSvg:any;
    addPinSvg:any;
    checkedCircleSvg:any;
}



const IconLib: IconLibI = {
    angleLeftSvg: AngleLeftSvg,
    angleRightSvg: AngleRightSvg,
    arrowLeftSvg: ArrowLeftSvg,
    arrowRightSvg: ArrowRightSvg,
    newCommentSvg: NewCommentSvg,
    medicalChartSvg: MedicalChartSvg,
    menuSvg: MenuSvg,
    closeSvg:CloseSvg,
    closeSquareSvg: CloseSquareSvg,
    wrenchSvg: WrenchSvg,
    pencilSvg: PencilSvg,
    timeKeepingSvg: TimeKeepingSvg,
    gridLayoutSvg: GridLayoutSvg,
    smileySvg: SmileySvg,
    tractorSvg: TractorSvg,
    agendaSvg: AgendaSvg,
    contentPostSvg: ContentPostSvg,
    menuFullSvg: MenuFullSvg,
    logoutSvg: LogoutSvg,
    lockSvg: LockSvg,
    chatAppSvg: ChatAppSvg,
    sunAndMoonSvg: SunAndMoonSvg,
    filterDataSvg: FilterDataSvg,
    editTextSvg: EditTextSvg,
    userAddressSvg: UserAddressSvg,
    webcamSvg: WebcamSvg,
    messagingAppSvg: MessagingAppSvg,
    editSvg: EditSvg,
    edit2Svg: Edit2Svg,
    deleteSvg: DeleteSvg,
    deleteCircleSvg: DeleteCircleSvg,
    viewSvg: ViewSvg,
    hiddenSvg: HiddenSvg,
    businessReportSvg: BusinessReportSvg,
    trashSvg: TrashSvg,
    searchSvg: SearchSvg,
    searchFindSvg: SearchFindSvg,
    moreSvg: MoreSvg,
    editUserSvg: EditUserSvg,
    splitArrowSvg: SplitArrowSvg,
    priorityWarningSvg: PriorityWarningSvg,
    plusSvg: PlusSvg,
    minusSvg: MinusSvg,
    gpsMapSvg: GpsMapSvg,
    squareBulletedListSvg: SquareBulletedListSvg,
    aimSvg: AimSvg,
    squareSvg: SquareSvg,
    qrCodeSvg: QrCodeSvg,
    paperStackSvg: PaperStackSvg,
    angleDownSvg: AngleDownSvg,
    angleUpSvg: AngleUpSvg,
    addCircleSvg: AddCircleSvg,
    binSvg: BinSvg,
    synchronizeSvg: SynchronizeSvg,
    downloadSvg: DownloadSvg,
    filessvg: FilesSvg,
    uploadSvg: UploadSvg,
    documentSvg: DocumentSvg,
    hexagonalWarningSvg: HexagonalWarningSvg,
    eraserSvg: EraserSvg,
    reloadSvg: ReloadSvg,
    addPinSvg: AddPinSvg,
    checkedCircleSvg: CheckedCircleSvg
}


  
export default IconLib;
